<template>
  <div class="ac-card-content">
    <div class="arch-header-container">
      <div class="flex-row">
        <img src="@shared/assets/img/general/eye-2.png" class="ac-info" alt="Information">
        <div class="ac-header">
          Archive Plan
        </div>
      </div>
    </div>
    <div class="arch-body-ft-container">
      <div class="ac-body-container">
        <div class="ac-body">
          <div class="flex-row just-between margin-bottom-12">
            <div class="arch-info">
              {{ selectedPlan?.name }} Plan
            </div>
            <div class="arch-info">
              Active: {{ selectedPlan?.activeMembers }}
            </div>
          </div>
          <div class="arch-body-text">
            This plan will no longer be displayed to new customers. It
            will only remain visible for existing customers who signed
            up for this plan.
          </div>
        </div>
      </div>
      <div class="arch-ft-container">
        <button type="button" class="secondary-button" @click="close">
          Cancel
        </button>
        <button type="button" class="primary-button active" @click="submit">
          Archive
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

export default {
  name: 'ArchivePlan',
  mixins: [partnerSettingsMixin],
  props: {
    close: Function,
    submit: Function,
  },
  computed: {
    hasActiveMembers() {
      return this.selectedPlan.activeMembers > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.arch-info {
  font-size: 18px;
  font-weight: 600;
}

.arch-header-container {
  padding: 24px 24px 0px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .ac-header {
    font-size: 1.25rem;
    font-weight: 600;
    margin-left: 12px;
  }

  .ac-info {
    width: 25px;
    object-fit: contain;
    margin-right: 6px;
  }
}

.arch-body-text {
  margin-top: 38px;
  font-size: 16px;
  color: #7F8290;
  text-align: justify;
}

.arch-body-ft-container {
  justify-content: space-between;
  margin-top: -14px;
  display: grid;
  gap: 22px;
}

.arch-ft-container {
  display: flex;
  align-items: end;
  gap: 16px;
  justify-content: end !important;
  margin: 0 24px;

  .secondary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $WHITE;
    border: solid 4px $NBLUE100;
    border-radius: 8px;
    color: $NBLUE100;
    padding: 12px 18px;
    font-weight: 600;

    &.blue {
      background-color: $NBLUE100;
      opacity: 0.3;
      color: $NBLUE100;
    }
  }

  .primary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: solid 4px $NBLUE100;
    background-color: $NBLUE100;
    border-radius: 8px;
    color: $WHITE;
    padding: 12px 18px;
    font-weight: 600;

    &.active {
      background-color: $NBLUE100;
    }

    &.inactive {
      opacity: 0.3;
    }
  }
}
</style>
